export default "__VITE_ASSET__BaPOSPf8__"